import React, { useEffect } from 'react';
import './App.css';
import { initializeApp } from "firebase/app";
//import { getConstantValue } from 'typescript';
// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import { getDatabase,  ref, child, get,set,push,update, onValue} from "firebase/database";
//import { count } from 'console';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAdwmzFEiR3WNamvR5uQ_5C_Mmh1nM46dI",
  authDomain: "chainedmom.firebaseapp.com",
  databaseURL: "https://chainedmom-default-rtdb.firebaseio.com",
  projectId: "chainedmom",
  storageBucket: "chainedmom.appspot.com",
  messagingSenderId: "1093669308877",
  appId: "1:1093669308877:web:cb07ab910f1771c6c2dc84",
  measurementId: "G-W97PWS4S07"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
// Get a list of cities from your database
const db = getDatabase();
const dbRef = ref(db);

var signItems: any[] =[];
const styles = {
  bold: {fontWeight: 'bold'},
  italic: {fontStyle: 'italic'},
  underline: {textDecorationLine: 'underline'},
  redfont: {color:'red'}
}
function App() {
  const [org,setOrgName] = React.useState("无");
  const [name,setName] = React.useState("");
  const [comment, setComment] = React.useState("");
  const [total,setTotal] = React.useState(0);
  const [signList,setSign] = React.useState<any[]>([]);
  useEffect(() => {
    get(child(dbRef, `sign`)).then((snapshot) => {
      var list: any[] =[];
      var total: number = 0;
      snapshot.forEach((c) => {
        //console.log("c.key",c.key);
        list.push({"name":'org', "comment": c.key + " " + c.size});
        var l: any[] =[];
        c.forEach((d) => {
          total += d.size;
          d.forEach((childSnapshot) => {
            const childKey = childSnapshot.key;
            const childData = childSnapshot.val();
            //console.log("childKey",childKey,childData);
            l.push({"name":childKey, "comment": childData});
          });
        });
        list = list.concat(l.reverse());
      });
      signItems = list.map((d, index) => d.name == 'org'? 
      <div key={index + d.name}><br></br>机构名: {d.comment}</div> 
      : <div key={index + d.name}>{d.name}: &nbsp;<span style={styles.italic}>{d.comment}</span></div>);
      setTotal(total);
       setSign(signItems);
    });
  });
  
  const handleOnOrgChange = (event: { target: { value: any } }) => {
    setOrgName(event.target.value);
  };
  const handleOnNameChange = (event: { target: { value: any } }) => {
    setName(event.target.value);
  };
  const handleOnCommentChange = (event: { target: { value: any } }) => {
    setComment(event.target.value);
  };
  const buttonHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    const button: HTMLButtonElement = event.currentTarget;
    realSign(org,name);
  };
  const realSign = (org: string, name: string) =>{
    push(ref(db,'sign/' + org ), {
      [name]: comment
    });
    setOrgName("");
    setName("");
    setComment("");
  }
  return (
    <div >
      <div>
        <header className='App-header'>
          解放锁链行动 —— 从解救徐州丰县锁链女开始
        </header>
        <div>
      姓名：<input
        type="text"
        value={name}
        className="form-control"
        onChange={handleOnNameChange} maxLength={16}
      />
      机构：      
        <input
        type="text"
        value={org}
        className="form-control"
        onChange={handleOnOrgChange} maxLength={16}
      /><br></br>
      留言：<input
        type="text"
        value={comment}
        className="form-control"
        onChange={handleOnCommentChange} maxLength={256}
      />
      <button onClick={buttonHandler} className="button" name="button 1">
         提交
        </button><br></br>
        {/* <div style={styles.redfont}>*请自行保护隐私，即使在海外父母双亡的华人还是处于威权恐吓之下</div> */}
        </div><br></br>
        <div>作为普罗大众，能做的不多，我们只能：<br></br>
          1. 抵制徐州的一切，跟徐州做生意就是骨子里的纵容，哪里的生意不可以做呢？给自己的良心一点余地，给自己的儿女积累一点福德。 
          <br></br>2. 签名 
          <br></br>3. 反对任何将拐卖妇女儿童打击范围局限在徐州甚至丰县的图谋</div>
          <div><br></br>
            诉求:<br></br>
          1. 让锁链女说话，让她回家，她能说话，能思考，哪里的口音，家乡在哪里，如果突然不能说话，只能是政府行为
          <br></br>2. 让任何人去丰县及相邻重度非重度拐卖县区任意访查,不接受任何不能重复验证不能质疑的结论
          <br></br>3. 发对任何对勇敢去丰县支援的自愿者的打压和非法拘禁
          <br></br>最新的中央媒体背书的结论验证了大众对政府的不信任，动用公权力维稳一个没有任何反政府倾向的反拐卖自发行为，突破了人伦底线也损害了政府的威信。
          </div>
        <p>
        签名总数: {total}
        </p>
        <div>
          {/* 组织总计： <br></br>{orgList}<br></br> */}
          签名如下 <br></br>{signList}
        </div>
      </div>
    </div>
  );
}

export default App;
